module.exports = __webpack_public_path__ + "img/mn.mne3e8c5f.svg";